import React, { memo, useState, lazy, Suspense } from "react";
import { useDispatch, useSelector } from "react-redux";
import PushNotifications from "./pushNotifications";
import AvatarComponent from "./avatar";
import KeyBoardComponent from "./keyBoard";
import { Home } from "icons";
import { selectLocale } from "redux/app/selectors";
import { deleteAllCookies, clearLocalStorage } from "helpers";
import { adminApp } from "api/constants";
import style from "./style.module.scss";
import LabelPicker from "components/LabelPicker";
import SegmentationTopBar from "components/SegmentationTopBar";
import CountTiming from "./countTiming";
import LanguageSelector from "components/LanguageSelector";
import { changeLanguage } from "redux/app/actions";
import AccountSwitcher from "./AccountSwitcher";

const LogoutConfirm = lazy(() => import("components/Modal"));

function TopBar() {
  const dispatch = useDispatch();
  const [isOpenLogout, setIsOpenLogout] = useState(false);
  const locale = useSelector(selectLocale);

  const logout = () => {
    deleteAllCookies();
    clearLocalStorage();
    window.location.replace(adminApp);
  };

  const handleSelectLocale = (event) => {
    dispatch(changeLanguage(event.target.value));
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };

  return (
    <>
      <nav className={style.navbar}>
        <a href={adminApp}>
          <Home className={style.homeIcon} />
        </a>
        <div className={style.labelPicker}>
          <LabelPicker />
        </div>
        <SegmentationTopBar />
        <div className={style.funcButtons}>
          <AccountSwitcher />
          <div className={style.language}>
            <LanguageSelector
              locale={locale}
              onSelectLocale={handleSelectLocale}
            />
          </div>
          <CountTiming />
          <KeyBoardComponent />
          <PushNotifications />
          <AvatarComponent />
        </div>
      </nav>
      {isOpenLogout && (
        <Suspense fallback={<></>}>
          <LogoutConfirm
            title="Confirmation"
            content="Do you really want to log out from AI Cycle Data Platform ?"
            isOpen={isOpenLogout}
            setIsOpen={(value) => setIsOpenLogout(value)}
            handleSubmit={logout}
          />
        </Suspense>
      )}
    </>
  );
}

export default memo(TopBar);
